export interface MonthlyReportRecipient {
  id: string;
  email: string;
  language: string;
  accountId?: string;
  userId?: string;
}

export interface MonthlyReportRecipientState {
  recipients: MonthlyReportRecipient[];
  state: 'init' | 'loading' | 'loaded' | 'pending';
}

export enum MonthlyReportRecipientActionTypes {
  GET_MONTHLY_REPORT_RECIPIENTS_REQUEST = 'esmiley/monthly-reports/GET_MONTHLY_REPORT_RECIPIENTS_REQUEST',
  GET_MONTHLY_REPORT_RECIPIENTS = 'esmiley/monthly-reports/GET_MONTHLY_REPORT_RECIPIENTS',
  UPDATE_MONTHLY_REPORT_RECIPIENT_REQUEST = 'esmiley/monthly-reports/UPDATE_MONTHLY_REPORT_RECIPIENT_REQUEST',
  UPDATE_MONTHLY_REPORT_RECIPIENT = 'esmiley/monthly-reports/UPDATE_MONTHLY_REPORT_RECIPIENT',
  DELETE_MONTHLY_REPORT_RECIPIENT_REQUEST = 'esmiley/monthly-reports/DELETE_MONTHLY_REPORT_RECIPIENT_REQUEST',
  DELETE_MONTHLY_REPORT_RECIPIENT = 'esmiley/monthly-reports/DELETE_MONTHLY_REPORT_RECIPIENT',
  CREATE_MONTHLY_REPORT_RECIPIENT_REQUEST = 'esmiley/monthly-reports/CREATE_MONTHLY_REPORT_RECIPIENT_REQUEST',
  CREATE_MONTHLY_REPORT_RECIPIENT = 'esmiley/monthly-reports/CREATE_MONTHLY_REPORT_RECIPIENT'
}

type GetMonthlyReportRecipientsRequestAction = {
  type: MonthlyReportRecipientActionTypes.GET_MONTHLY_REPORT_RECIPIENTS_REQUEST;
};
type GetMonthlyReportRecipientsAction = {
  type: typeof MonthlyReportRecipientActionTypes.GET_MONTHLY_REPORT_RECIPIENTS;
  payload: MonthlyReportRecipient[];
};

type UpdateMonthlyReportRecipientRequestAction = {
  type: MonthlyReportRecipientActionTypes.UPDATE_MONTHLY_REPORT_RECIPIENT_REQUEST;
};

type UpdateMonthlyReportRecipientAction = {
  type: typeof MonthlyReportRecipientActionTypes.UPDATE_MONTHLY_REPORT_RECIPIENT;
  payload: MonthlyReportRecipient;
};

type DeleteMonthlyReportRecipientRequestAction = {
  type: MonthlyReportRecipientActionTypes.DELETE_MONTHLY_REPORT_RECIPIENT_REQUEST;
};

type DeleteMonthlyReportRecipientAction = {
  type: typeof MonthlyReportRecipientActionTypes.DELETE_MONTHLY_REPORT_RECIPIENT;
  payload: MonthlyReportRecipient['id'];
};

type CreateMonthlyReportRecipientRequestAction = {
  type: MonthlyReportRecipientActionTypes.CREATE_MONTHLY_REPORT_RECIPIENT_REQUEST;
};

type CreateMonthlyReportRecipientAction = {
  type: typeof MonthlyReportRecipientActionTypes.CREATE_MONTHLY_REPORT_RECIPIENT;
  payload: MonthlyReportRecipient;
};

export type MonthlyReportRecipientActions =
  | GetMonthlyReportRecipientsRequestAction
  | GetMonthlyReportRecipientsAction
  | UpdateMonthlyReportRecipientRequestAction
  | UpdateMonthlyReportRecipientAction
  | DeleteMonthlyReportRecipientRequestAction
  | DeleteMonthlyReportRecipientAction
  | CreateMonthlyReportRecipientRequestAction
  | CreateMonthlyReportRecipientAction;
